module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "yjtz-box"
  }, [(_vm.data) ? _c('div', {
    staticClass: "yjtz-content"
  }, [_c('div', {
    staticClass: "yjtz-info-card"
  }, [_c('div', {
    staticClass: "yjtz-info-left"
  }, [_c('span', {
    staticClass: "yjtz-info-title"
  }, [_vm._v(_vm._s(_vm.data.emailInfo.title))]), _vm._v(" "), _c('span', {
    staticClass: "yjtz-info-desc"
  }, [_vm._v(_vm._s(_vm.$t('all.shoujianren')) + "：" + _vm._s(_vm.data.emailInfo.recipient))])]), _vm._v(" "), _c('span', {
    staticClass: "yjtz-info-tag"
  }, [_vm._v(_vm._s(_vm.$t('all.yifasong')))])]), _vm._v(" "), _c('div', {
    staticClass: "yjtz-type-row"
  }, [_c('div', {
    class: _vm.data.liveType === 1 ? 'yjtz-type-active' : 'yjtz-type'
  }, [_vm._v(_vm._s(_vm.$t('all.shoujizhibo')))]), _vm._v(" "), _c('div', {
    class: _vm.data.liveType === 2 ? 'yjtz-type-active' : 'yjtz-type'
  }, [_vm._v("OBS" + _vm._s(_vm.$t('all.zhibo')))])]), _vm._v(" "), _c('div', {
    staticClass: "yjtz-mail-card"
  }, [_c('span', {
    staticClass: "yjtz-mail-title"
  }, [_vm._v(_vm._s(_vm.data.emailInfo.statusTitle))]), _vm._v(" "), _c('span', {
    staticClass: "yjtz-mail-desc",
    domProps: {
      "innerHTML": _vm._s(_vm.data.emailInfo.content.replace(/\n/g, '<br>'))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "yjtz-item"
  }, [_c('span', {
    staticClass: "yjtz-item-label"
  }, [_vm._v(_vm._s(_vm.$t('all.youjianbianhao')))]), _vm._v(" "), _c('span', {
    staticClass: "yjtz-item-value yjtz-text-green"
  }, [_vm._v(_vm._s(_vm.data.emailInfo.emailNumber))])]), _vm._v(" "), _c('div', {
    staticClass: "yjtz-btn",
    on: {
      "click": _vm.handleResend
    }
  }, [_vm._v(_vm._s(_vm.$t('all.chongxinfasong')))])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-26977070"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/pages/youjiantongzhi/youjiantongzhi.vue
// module id = 1005
// module chunks = 1